<template>
    <div
        class="modal fade"
        ref="modelElementRef"
        tabindex="-1"
        role="dialog"
        :id="modalId"
    >
        <div class="modal-dialog mw-650px">
            <div class="modal-content">
                <slot v-if="isOpen"></slot>
            </div>
        </div>
    </div>
</template>

<script setup>
import { getCurrentInstance, onMounted, ref, watch } from "vue";

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false,
    },
});

const isOpen = ref(false);
const modelElementRef = ref(null);

const emit = defineEmits(["update:modelValue", "close", "open"]);

const vm = getCurrentInstance();
const modalId = `id-${vm.uid}`;

function open() {
    isOpen.value = true;
    $(`#${modalId}`).modal("show");
}

const close = () => {
    isOpen.value = false;
    $(`#${modalId}`).modal("hide");
};

onMounted(() => {
    isOpen.value = props.modelValue;
    const modalElement = modelElementRef.value;
    if (!modalElement) {
        return;
    }
    modalElement.addEventListener("hidden.bs.modal", () => {
        isOpen.value = false;
        emit("close");
    });
    modalElement.addEventListener("shown.bs.modal", emit("open"));
});

watch(isOpen, () => {
    emit("update:modelValue", isOpen.value);
});
watch(
    () => props.modelValue,
    (val) => {
        if (val) {
            open();
        } else {
            close();
        }
    }
);

defineExpose({
    open,
    close,
});
</script>

<style lang="scss" scoped></style>
